module.exports = __webpack_public_path__ + "img/star-map_white.00abae0.png";